/**
 * API Module
 *
 * Apollo Client setup and GraphQL utilities for web
 */

// Unified Client - RECOMMENDED
export {
    setUnifiedClient,
    getUnifiedClient,
    isUnifiedClientInitialized,
    setAuthTokenProvider,
    setCustomHeadersGetter,
    setOnAuthError,
    setCoreClientCacheConfig,
    getAuthToken,
    setAuthToken,
    clearAuthToken,
    resetUnifiedClient,
    createCoreApolloClient,
    createErrorLink,
    createAuthLink,
} from './unified-client';
export type {
    TokenGetter,
    TokenSetter,
    AuthTokenProvider,
    UnifiedClientConfig,
    CoreApolloClientOptions,
    RefreshedToken,
} from './unified-client';

// Legacy exports - for backward compatibility
export { initClient, getClient, setClient } from './client';
export type { InitClientConfig, InitClientResult } from './client';

// Provider
export { ApiProvider, useApiContext } from './providers/api.provider';
